import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Tabs, Tab, Box, Typography, Switch, FormControlLabel,
  TextField, Table, TableHead, TableBody, TableRow,
  TableCell, IconButton, Button, Alert, CircularProgress,
  Accordion, AccordionSummary, AccordionDetails, Chip,
  Divider, InputAdornment,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import SearchIcon from '@mui/icons-material/Search';
import AceEditor from 'react-ace';
import 'ace-builds/webpack-resolver';
import 'ace-builds/src-noconflict/mode-yaml';
import 'ace-builds/src-noconflict/theme-monokai';
import jsyaml from 'js-yaml';

// ── Default OMK 2020 lookup tables (source: Customer Risk Rating Tool.xlsm) ──

var DEFAULT_CUSTOMER_TYPES = [
  { label: 'Individual-Citizen-Resident', score: 3.33 },
  { label: 'Individual-Citizen-Non-Resident', score: 6.67 },
  { label: 'Individual-Foreigner', score: 11.67 },
  { label: 'Local Private Company', score: 0 },
  { label: 'Local institutional client', score: 0 },
  { label: 'Local Listed Company', score: 0 },
  { label: 'Partnership & other', score: 0 },
  { label: 'Local Trust', score: 0 },
  { label: 'Foreign Institutional client', score: 0 },
  { label: 'Foreign Listed Company', score: 0 },
  { label: 'Foreign trust, partnership & other', score: 0 },
];

var DEFAULT_CHANNELS = [
  { label: 'face-to-face', score: 2 },
  { label: 'non-face-to-face', score: 5 },
];

var DEFAULT_OCCUPATIONS = [
  { label: 'N/A', score: 0 },
  { label: 'Salaried Employee', score: 4 },
  { label: 'Bank Employee', score: 26 },
  { label: 'Self Employed', score: 26 },
  { label: 'Student', score: 22 },
  { label: 'Pensioner', score: 4 },
  { label: 'Non-Income Generating Dependant', score: 26 },
  { label: 'Laywer/Advocate', score: 26 },
  { label: 'Real Estate Dealer', score: 26 },
  { label: 'Jeweller/Precious Metal Dealer', score: 26 },
  { label: 'Notary/Accountant/Auditor', score: 26 },
];

var DEFAULT_INDUSTRIES = [
  { label: 'Agriculture, forestry and fishing', score: 14 },
  { label: 'Mining and quarrying', score: 27 },
  { label: 'Manufacturing', score: 14 },
  { label: 'Electricity, gas, steam and air conditioning supply', score: 3 },
  { label: 'Water supply and waste management', score: 3 },
  { label: 'Construction', score: 27 },
  { label: 'Wholesale and retail trade', score: 14 },
  { label: 'Transportation and storage', score: 14 },
  { label: 'Accommodation and food service activities', score: 14 },
  { label: 'Information and communication', score: 14 },
  { label: 'Financial and insurance activities', score: 27 },
  { label: 'Real estate activities', score: 27 },
  { label: 'Professional, scientific and technical activities', score: 14 },
  { label: 'Administrative and support service activities', score: 14 },
  { label: 'Public administration and defence', score: 14 },
  { label: 'Education', score: 3 },
  { label: 'Human health and social work', score: 3 },
  { label: 'Arts, entertainment and recreation', score: 14 },
  { label: 'Other service activities', score: 14 },
  { label: 'Activities of households as employers', score: 3 },
  { label: 'Activities of extraterritorial organisations', score: 3 },
];

var DEFAULT_PRODUCTS = [
  { label: 'Education Savings Plan', score: 1 },
  { label: 'Elimika Education Plan', score: 1 },
  { label: 'Lengo Savings Plan', score: 1 },
  { label: 'Hakika Savings Plan', score: 1 },
  { label: 'Max Investment Plan', score: 1 },
  { label: 'GreenLight', score: 1 },
  { label: 'Rafiki Halisi Investment Plan', score: 1 },
  { label: 'Last Expense Cover', score: 1 },
  { label: 'Pension Cover', score: 1 },
  { label: 'Group Life Assurance', score: 1 },
  { label: 'Group Credit', score: 1 },
  { label: 'Umbrella Pension Plan', score: 1 },
  { label: 'Money Market Fund', score: 3.5 },
  { label: 'Equity Fund', score: 3.5 },
  { label: 'Bond Fund', score: 2 },
  { label: 'Balanced Fund', score: 2 },
  { label: 'Toboa Investment Plan', score: 2 },
  { label: 'Unit Trust Mobile solution', score: 1 },
  { label: 'Private Wealth Management', score: 1 },
  { label: 'Institutional Wealth Management', score: 1 },
];

var DEFAULT_INCOME_RANGES = [
  { label: 'Below 10,000', score: 20 },
  { label: '10,000 - 50,000', score: 10 },
  { label: '50,000 - 200,000', score: 5 },
  { label: 'Above 200,000', score: 3 },
];

var DEFAULT_PEP_CATEGORIES = [
  { label: 'Domestic PEP', score: 100 },
  { label: 'Foreign PEP', score: 90 },
  { label: 'International Organization PEP', score: 80 },
  { label: 'Family Member of PEP', score: 70 },
  { label: 'Close Associate of PEP', score: 60 },
];

/* eslint-disable */
var DEFAULT_COUNTRIES = [
  { label: 'Afghanistan', score: 30.0 },
  { label: 'Albania', score: 15.0 },
  { label: 'Algeria', score: 22.2 },
  { label: 'Andorra', score: 5.7 },
  { label: 'Angola', score: 17.4 },
  { label: 'Antigua & Barbuda', score: 9.0 },
  { label: 'Argentina', score: 15.9 },
  { label: 'Armenia', score: 11.7 },
  { label: 'Aruba', score: 7.2 },
  { label: 'Australia', score: 8.7 },
  { label: 'Austria', score: 9.0 },
  { label: 'Azerbaijan', score: 13.8 },
  { label: 'Bahamas', score: 10.8 },
  { label: 'Bahrain', score: 13.2 },
  { label: 'Bangladesh', score: 14.1 },
  { label: 'Barbados', score: 10.8 },
  { label: 'Belarus', score: 18.6 },
  { label: 'Belgium', score: 8.7 },
  { label: 'Belize', score: 13.5 },
  { label: 'Benin', score: 17.4 },
  { label: 'Bermuda', score: 8.1 },
  { label: 'Bolivia', score: 16.5 },
  { label: 'Bosnia and Herzegovina', score: 30.0 },
  { label: 'Botswana', score: 11.4 },
  { label: 'Brazil', score: 14.7 },
  { label: 'British Indian Ocean Territory', score: 12.0 },
  { label: 'British Virgin Islands', score: 10.5 },
  { label: 'Brunei Darussalam', score: 8.1 },
  { label: 'Bulgaria', score: 10.5 },
  { label: 'Burkina Faso', score: 14.4 },
  { label: 'Burundi', score: 22.8 },
  { label: 'Cambodia', score: 16.2 },
  { label: 'Cameroon', score: 12.0 },
  { label: 'Canada', score: 9.0 },
  { label: 'Cape Verde', score: 13.2 },
  { label: 'Cayman Islands', score: 9.6 },
  { label: 'Central African Republic', score: 30.0 },
  { label: 'Chad', score: 17.4 },
  { label: 'Chile', score: 9.3 },
  { label: 'China', score: 17.4 },
  { label: 'Colombia', score: 15.0 },
  { label: 'Comoros', score: 15.3 },
  { label: 'Congo, Democratic Republic', score: 30.0 },
  { label: 'Congo, Republic', score: 17.4 },
  { label: 'Cook Islands', score: 6.6 },
  { label: 'Costa Rica', score: 13.8 },
  { label: 'Croatia', score: 12.0 },
  { label: 'Cuba', score: 16.8 },
  { label: 'Curacao', score: 7.2 },
  { label: 'Cyprus', score: 10.8 },
  { label: 'Czech Republic', score: 11.1 },
  { label: 'Denmark', score: 6.0 },
  { label: 'Djibouti', score: 14.7 },
  { label: 'Dominica', score: 11.7 },
  { label: 'Dominican Republic', score: 16.2 },
  { label: 'Ecuador', score: 19.2 },
  { label: 'Egypt', score: 30.0 },
  { label: 'El Salvador', score: 15.0 },
  { label: 'Equatorial Guinea', score: 13.5 },
  { label: 'Eritrea', score: 18.9 },
  { label: 'Estonia', score: 6.6 },
  { label: 'Ethiopia', score: 30.0 },
  { label: 'Fiji', score: 8.7 },
  { label: 'Finland', score: 4.8 },
  { label: 'France', score: 11.7 },
  { label: 'French Guiana', score: 11.7 },
  { label: 'French Polynesia', score: 11.7 },
  { label: 'Gabon', score: 12.0 },
  { label: 'Gambia', score: 16.2 },
  { label: 'Georgia', score: 12.0 },
  { label: 'Germany', score: 11.1 },
  { label: 'Ghana', score: 16.5 },
  { label: 'Gibraltar', score: 7.5 },
  { label: 'Greece', score: 10.2 },
  { label: 'Greenland', score: 6.0 },
  { label: 'Grenada', score: 12.6 },
  { label: 'Guatemala', score: 16.2 },
  { label: 'Guernsey', score: 10.5 },
  { label: 'Guinea', score: 19.2 },
  { label: 'Guinea-Bissau', score: 25.5 },
  { label: 'Guyana', score: 16.2 },
  { label: 'Haiti', score: 21.9 },
  { label: 'Honduras', score: 16.5 },
  { label: 'Hong Kong', score: 10.5 },
  { label: 'Hungary', score: 12.3 },
  { label: 'Iceland', score: 7.5 },
  { label: 'India', score: 14.7 },
  { label: 'Indonesia', score: 20.1 },
  { label: 'Iran', score: 30.0 },
  { label: 'Iraq', score: 30.0 },
  { label: 'Ireland', score: 8.7 },
  { label: 'Isle of Man', score: 9.6 },
  { label: 'Israel', score: 9.3 },
  { label: 'Italy', score: 11.4 },
  { label: 'Ivory Coast / Cote d\'Ivoire', score: 18.3 },
  { label: 'Jamaica', score: 14.4 },
  { label: 'Japan', score: 9.6 },
  { label: 'Jersey', score: 10.5 },
  { label: 'Jordan', score: 17.1 },
  { label: 'Kazakhstan', score: 17.4 },
  { label: 'Kenya', score: 17.4 },
  { label: 'Kosovo (Serbia)', score: 12.9 },
  { label: 'Kuwait', score: 15.6 },
  { label: 'Kyrgyzstan', score: 18.0 },
  { label: 'Lao PDR', score: 17.1 },
  { label: 'Latvia', score: 9.9 },
  { label: 'Lebanon', score: 19.8 },
  { label: 'Lesotho', score: 17.4 },
  { label: 'Liberia', score: 19.2 },
  { label: 'Libya', score: 30.0 },
  { label: 'Liechtenstein', score: 8.4 },
  { label: 'Lithuania', score: 7.8 },
  { label: 'Luxembourg', score: 8.7 },
  { label: 'Macao', score: 10.5 },
  { label: 'Macedonia', score: 14.4 },
  { label: 'Madagascar', score: 10.5 },
  { label: 'Malawi', score: 14.4 },
  { label: 'Malaysia', score: 14.4 },
  { label: 'Maldives', score: 13.8 },
  { label: 'Mali', score: 18.3 },
  { label: 'Malta', score: 12.6 },
  { label: 'Marshall Islands', score: 15.9 },
  { label: 'Mauritania', score: 14.1 },
  { label: 'Mauritius', score: 11.4 },
  { label: 'Mexico', score: 14.7 },
  { label: 'Moldova', score: 14.7 },
  { label: 'Monaco', score: 5.1 },
  { label: 'Mongolia', score: 15.0 },
  { label: 'Montenegro', score: 12.9 },
  { label: 'Morocco', score: 17.1 },
  { label: 'Mozambique', score: 16.8 },
  { label: 'Myanmar/Burma', score: 20.7 },
  { label: 'Namibia', score: 11.4 },
  { label: 'Nauru', score: 7.8 },
  { label: 'Nepal', score: 16.2 },
  { label: 'Netherlands', score: 8.7 },
  { label: 'New Zealand', score: 6.0 },
  { label: 'Nicaragua', score: 16.2 },
  { label: 'Niger', score: 17.4 },
  { label: 'Nigeria', score: 22.2 },
  { label: 'North Korea', score: 30.0 },
  { label: 'Norway', score: 6.9 },
  { label: 'Oman', score: 6.9 },
  { label: 'Pakistan', score: 22.2 },
  { label: 'Palestine', score: 11.4 },
  { label: 'Panama', score: 18.0 },
  { label: 'Papua New Guinea', score: 14.1 },
  { label: 'Paraguay', score: 16.2 },
  { label: 'Peru', score: 16.5 },
  { label: 'Philippines', score: 18.9 },
  { label: 'Poland', score: 11.4 },
  { label: 'Portugal', score: 8.7 },
  { label: 'Puerto Rico', score: 6.6 },
  { label: 'Qatar', score: 12.6 },
  { label: 'Romania', score: 14.1 },
  { label: 'Russia Federation', score: 18.6 },
  { label: 'Rwanda', score: 14.4 },
  { label: 'Samoa', score: 12.0 },
  { label: 'Saudi Arabia', score: 17.1 },
  { label: 'Senegal', score: 14.7 },
  { label: 'Serbia', score: 16.8 },
  { label: 'Seychelles', score: 9.6 },
  { label: 'Sierra Leone', score: 16.5 },
  { label: 'Singapore', score: 8.7 },
  { label: 'Slovakia', score: 12.9 },
  { label: 'Slovenia', score: 10.5 },
  { label: 'Somalia', score: 30.0 },
  { label: 'South Africa', score: 11.7 },
  { label: 'South Korea', score: 9.6 },
  { label: 'South Sudan', score: 30.0 },
  { label: 'Spain', score: 13.2 },
  { label: 'Sri Lanka', score: 15.6 },
  { label: 'Sudan', score: 22.5 },
  { label: 'Suriname', score: 11.7 },
  { label: 'Swaziland', score: 10.8 },
  { label: 'Sweden', score: 6.3 },
  { label: 'Switzerland', score: 9.9 },
  { label: 'Syria', score: 30.0 },
  { label: 'Taiwan', score: 11.4 },
  { label: 'Tajikistan', score: 19.2 },
  { label: 'Tanzania', score: 16.2 },
  { label: 'Thailand', score: 19.2 },
  { label: 'Togo', score: 13.8 },
  { label: 'Trinidad and Tobago', score: 15.6 },
  { label: 'Tunisia', score: 30.0 },
  { label: 'Turkey', score: 15.0 },
  { label: 'Turkmenistan', score: 15.9 },
  { label: 'Uganda', score: 30.0 },
  { label: 'Ukraine', score: 23.4 },
  { label: 'United Arab Emirates', score: 16.2 },
  { label: 'United Kingdom', score: 12.0 },
  { label: 'Uruguay', score: 10.8 },
  { label: 'USA', score: 12.0 },
  { label: 'Uzbekistan', score: 16.5 },
  { label: 'Vanuatu', score: 30.0 },
  { label: 'Venezuela', score: 20.4 },
  { label: 'Vietnam', score: 16.2 },
  { label: 'Yemen', score: 30.0 },
  { label: 'Zambia', score: 12.9 },
  { label: 'Zimbabwe', score: 22.2 },
];
/* eslint-enable */

var WEIGHT_META = {
  customer_type: {
    label: 'Customer Type',
    desc: 'Individual citizen vs foreigner vs company',
  },
  channel: {
    label: 'Channel',
    desc: 'Face-to-face vs non-face-to-face onboarding',
  },
  occupation: {
    label: 'Occupation',
    desc: 'Customer\'s stated profession',
  },
  country: {
    label: 'Country',
    desc: 'Applied to citizenship, birth and residence',
  },
  industry: {
    label: 'Industry Sector',
    desc: 'Business or employer\'s industry sector',
  },
  business_product: {
    label: 'Business Product',
    desc: 'Insurance product being applied for',
  },
  income_range: { label: 'Income Range', desc: 'Customer monthly income band' },
};

var SCORE_TABLE_META = [
  { key: 'customer_type', label: 'Customer Type', defaults: DEFAULT_CUSTOMER_TYPES },
  { key: 'channel', label: 'Channel', defaults: DEFAULT_CHANNELS },
  { key: 'occupation', label: 'Occupation', defaults: DEFAULT_OCCUPATIONS },
  { key: 'industry', label: 'Industry Sector', defaults: DEFAULT_INDUSTRIES },
  { key: 'business_product', label: 'Business Product', defaults: DEFAULT_PRODUCTS },
  { key: 'income_range', label: 'Income Range', defaults: DEFAULT_INCOME_RANGES },
  { key: 'pep_category', label: 'PEP Category', defaults: DEFAULT_PEP_CATEGORIES },
  { key: 'country', label: 'Country Risk', defaults: DEFAULT_COUNTRIES, searchable: true },
];

// ── Helpers ────────────────────────────────────────────────────────────────────

function mapToArray(tableMap, defaults) {
  if (tableMap && typeof tableMap === 'object' && !Array.isArray(tableMap)) {
    return Object.keys(tableMap).map(function(k) {
      return { label: k, score: Number(tableMap[k]) || 0 };
    });
  }
  return defaults.map(function(r) {
    return { label: r.label, score: r.score };
  });
}

function arrayToMap(arr) {
  var map = {};
  arr.forEach(function(row) {
    if (row.label && row.label.trim()) {
      map[row.label.trim()] = Number(row.score) || 0;
    }
  });
  return map;
}

function parseYamlToForm(rawYaml) {
  var parsed;
  try {
    parsed = jsyaml.safeLoad(rawYaml);
  } catch (e) {
    return null;
  }
  if (!parsed || typeof parsed !== 'object') return null;

  var scoring = parsed.scoring || {};
  var weights = scoring.weights || {};
  var thresholds = scoring.thresholds || {};
  var tables = scoring.tables || {};

  return {
    partner: parsed.partner || '',
    enabled: parsed.enabled !== false,
    weights: {
      customer_type: weights.customer_type != null ? weights.customer_type : 0.9388,
      channel: weights.channel != null ? weights.channel : 2.058,
      occupation: weights.occupation != null ? weights.occupation : 0.20,
      country: weights.country != null ? weights.country : 0.6369,
      industry: weights.industry != null ? weights.industry : 0.6464,
      business_product: weights.business_product != null ? weights.business_product : 0.3333,
      income_range: weights.income_range != null ? weights.income_range : 0,
    },
    thresholds: {
      medium: thresholds.medium != null ? Number(thresholds.medium) : 40,
      high: thresholds.high != null ? Number(thresholds.high) : 75,
    },
    sanction_penalty: scoring.sanction_penalty != null
      ? Number(scoring.sanction_penalty) : 10,
    pep_penalty: scoring.pep_penalty != null ? Number(scoring.pep_penalty) : 100,
    tables: {
      customer_type: mapToArray(tables.customer_type, DEFAULT_CUSTOMER_TYPES),
      channel: mapToArray(tables.channel, DEFAULT_CHANNELS),
      occupation: mapToArray(tables.occupation, DEFAULT_OCCUPATIONS),
      industry: mapToArray(tables.industry, DEFAULT_INDUSTRIES),
      business_product: mapToArray(tables.business_product, DEFAULT_PRODUCTS),
      income_range: mapToArray(tables.income_range, DEFAULT_INCOME_RANGES),
      pep_category: mapToArray(tables.pep_category, DEFAULT_PEP_CATEGORIES),
      country: mapToArray(tables.country, DEFAULT_COUNTRIES),
    },
    _input: parsed.input || null,
    _output: parsed.output || null,
  };
}

function serializeFormToYaml(form) {
  var obj = {
    partner: form.partner,
    enabled: form.enabled,
    scoring: {
      weights: {
        customer_type: Number(form.weights.customer_type) || 0,
        channel: Number(form.weights.channel) || 0,
        occupation: Number(form.weights.occupation) || 0,
        country: Number(form.weights.country) || 0,
        industry: Number(form.weights.industry) || 0,
        business_product: Number(form.weights.business_product) || 0,
        income_range: Number(form.weights.income_range) || 0,
      },
      thresholds: {
        medium: Number(form.thresholds.medium) || 40,
        high: Number(form.thresholds.high) || 75,
      },
      sanction_penalty: Number(form.sanction_penalty) || 10,
      pep_penalty: Number(form.pep_penalty) || 100,
      tables: {
        customer_type: arrayToMap(form.tables.customer_type),
        channel: arrayToMap(form.tables.channel),
        occupation: arrayToMap(form.tables.occupation),
        industry: arrayToMap(form.tables.industry),
        business_product: arrayToMap(form.tables.business_product),
        income_range: arrayToMap(form.tables.income_range),
        pep_category: arrayToMap(form.tables.pep_category),
        country: arrayToMap(form.tables.country),
      },
    },
  };
  if (form._input) obj.input = form._input;
  if (form._output) obj.output = form._output;
  return jsyaml.safeDump(obj, { lineWidth: -1, quotingType: '"', noRefs: true });
}

function riskChip(score, medium, high) {
  var n = Number(score) || 0;
  if (n >= high) return { label: 'High', color: 'error' };
  if (n >= medium) return { label: 'Medium', color: 'warning' };
  return { label: 'Low', color: 'success' };
}

function defaultForm(partner) {
  return {
    partner: partner || '',
    enabled: true,
    weights: {
      customer_type: 0.9388,
      channel: 2.058,
      occupation: 0.20,
      country: 0.6369,
      industry: 0.6464,
      business_product: 0.3333,
      income_range: 0,
    },
    thresholds: { medium: 40, high: 75 },
    sanction_penalty: 10,
    pep_penalty: 100,
    tables: {
      customer_type: DEFAULT_CUSTOMER_TYPES.map(function(r) {
        return { label: r.label, score: r.score };
      }),
      channel: DEFAULT_CHANNELS.map(function(r) {
        return { label: r.label, score: r.score };
      }),
      occupation: DEFAULT_OCCUPATIONS.map(function(r) {
        return { label: r.label, score: r.score };
      }),
      industry: DEFAULT_INDUSTRIES.map(function(r) {
        return { label: r.label, score: r.score };
      }),
      business_product: DEFAULT_PRODUCTS.map(function(r) {
        return { label: r.label, score: r.score };
      }),
      income_range: DEFAULT_INCOME_RANGES.map(function(r) {
        return { label: r.label, score: r.score };
      }),
      pep_category: DEFAULT_PEP_CATEGORIES.map(function(r) {
        return { label: r.label, score: r.score };
      }),
      country: DEFAULT_COUNTRIES.map(function(r) {
        return { label: r.label, score: r.score };
      }),
    },
    _input: null,
    _output: null,
  };
}

// ── Styles ─────────────────────────────────────────────────────────────────────

var TH = {
  fontSize: 11, fontWeight: 700, color: '#6B7280',
  textTransform: 'uppercase', letterSpacing: '0.05em',
  bgcolor: '#F9FAFB', borderBottom: '1px solid #E5E7EB',
  py: 1, px: 1.5,
};
var TD = {
  fontSize: 13, color: '#374151',
  borderBottom: '1px solid #F3F4F6',
  py: 0.75, px: 1.5,
};

// ── Sub-components ─────────────────────────────────────────────────────────────

function TabPanel(props) {
  var children = props.children;
  var value = props.value;
  var index = props.index;
  if (value !== index) return null;
  return (
    <Box
      role="tabpanel"
      sx={{ flex: 1, overflow: 'auto', p: 2.5 }}
    >
      {children}
    </Box>
  );
}

function ThresholdBar(props) {
  var medium = Number(props.medium) || 40;
  var high = Number(props.high) || 75;
  var max = 100;
  var lowPct = (medium / max) * 100;
  var medPct = ((high - medium) / max) * 100;
  var highPct = ((max - high) / max) * 100;

  return (
    <Box sx={{ mt: 1, mb: 2 }}>
      <Box sx={{ display: 'flex', height: 24, borderRadius: 1, overflow: 'hidden' }}>
        <Box sx={{
          width: lowPct + '%', bgcolor: '#22C55E',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Typography sx={{ fontSize: 10, fontWeight: 700, color: '#fff' }}>
            LOW
          </Typography>
        </Box>
        <Box sx={{
          width: medPct + '%', bgcolor: '#F59E0B',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Typography sx={{ fontSize: 10, fontWeight: 700, color: '#fff' }}>
            MEDIUM
          </Typography>
        </Box>
        <Box sx={{
          width: highPct + '%', bgcolor: '#EF4444',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Typography sx={{ fontSize: 10, fontWeight: 700, color: '#fff' }}>
            HIGH
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
        <Typography sx={{ fontSize: 10, color: '#9CA3AF' }}>0</Typography>
        <Typography sx={{ fontSize: 10, color: '#9CA3AF' }}>{medium}</Typography>
        <Typography sx={{ fontSize: 10, color: '#9CA3AF' }}>{high}</Typography>
        <Typography sx={{ fontSize: 10, color: '#9CA3AF' }}>{max}+</Typography>
      </Box>
    </Box>
  );
}

function ScoreTableAccordion(props) {
  var meta = props.meta;
  var rows = props.rows;
  var medium = props.medium;
  var high = props.high;
  var onChange = props.onChange;
  var onAdd = props.onAdd;
  var onDelete = props.onDelete;

  var search = props.search;
  var onSearchChange = props.onSearchChange;
  var searchable = props.meta.searchable;

  var displayRows = searchable && search
    ? rows.filter(function(r) {
        return r.label.toLowerCase().indexOf(search.toLowerCase()) !== -1;
      })
    : rows;

  return (
    <Accordion disableGutters sx={{ mb: 1, border: '1px solid #E5E7EB', '&:before': { display: 'none' } }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: 44, bgcolor: '#F9FAFB' }}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, color: '#374151' }}>
          {meta.label}
        </Typography>
        <Typography sx={{ fontSize: 12, color: '#9CA3AF', ml: 1.5, alignSelf: 'center' }}>
          {rows.length} values
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        {searchable && (
          <Box sx={{ p: 1.5, borderBottom: '1px solid #F3F4F6' }}>
            <TextField
              size="small"
              placeholder="Search countries…"
              value={search}
              onChange={function(e) { onSearchChange(e.target.value); }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ fontSize: 16, color: '#9CA3AF' }} />
                  </InputAdornment>
                ),
              }}
              sx={{ width: 280 }}
            />
          </Box>
        )}
        <Box sx={{ maxHeight: 340, overflow: 'auto' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={TH}>Value</TableCell>
                <TableCell sx={{ ...TH, width: 110 }}>Score</TableCell>
                <TableCell sx={{ ...TH, width: 90 }}>Risk</TableCell>
                <TableCell sx={{ ...TH, width: 44 }} />
              </TableRow>
            </TableHead>
            <TableBody>
              {displayRows.map(function(row, idx) {
                var actualIdx = rows.indexOf(row);
                var chip = riskChip(row.score, medium, high);
                return (
                  <TableRow key={actualIdx} hover>
                    <TableCell sx={TD}>
                      <TextField
                        size="small"
                        value={row.label}
                        onChange={function(e) {
                          onChange(meta.key, actualIdx, 'label', e.target.value);
                        }}
                        variant="standard"
                        sx={{ width: '100%', '& input': { fontSize: 12 } }}
                      />
                    </TableCell>
                    <TableCell sx={TD}>
                      <TextField
                        size="small"
                        type="number"
                        value={row.score}
                        onChange={function(e) {
                          onChange(meta.key, actualIdx, 'score', e.target.value);
                        }}
                        variant="standard"
                        inputProps={{ step: 0.1, min: 0, style: { fontSize: 12 } }}
                        sx={{ width: 80 }}
                      />
                    </TableCell>
                    <TableCell sx={TD}>
                      <Chip
                        label={chip.label}
                        color={chip.color}
                        size="small"
                        sx={{ fontSize: 10 }}
                      />
                    </TableCell>
                    <TableCell sx={TD} align="center">
                      <IconButton
                        size="small"
                        onClick={function() { onDelete(meta.key, actualIdx); }}
                        sx={{ color: '#EF4444' }}
                      >
                        <DeleteOutlineIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
        <Box sx={{ p: 1.5, borderTop: '1px solid #F3F4F6' }}>
          <Button
            size="small"
            startIcon={<AddIcon />}
            onClick={function() { onAdd(meta.key); }}
            sx={{ textTransform: 'none', fontSize: 12 }}
          >
            Add row
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

// ── Main component ─────────────────────────────────────────────────────────────

class RiskConfigEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      form: null,
      countrySearch: '',
    };
  }

  componentDidMount() {
    this.initForm();
  }

  componentDidUpdate(prevProps) {
    var rawYaml = this.props.rawYaml;
    var isNew = this.props.isNew;
    var open = this.props.open;

    if (open && !prevProps.open) {
      this.setState({ tab: 0, countrySearch: '' });
    }
    if (rawYaml && rawYaml !== prevProps.rawYaml) {
      var parsed = parseYamlToForm(rawYaml);
      if (parsed) this.setState({ form: parsed });
    }
    if (isNew && isNew !== prevProps.isNew && open) {
      this.setState({
        form: defaultForm(this.props.partner),
        tab: 0,
        countrySearch: '',
      });
    }
  }

  initForm() {
    var rawYaml = this.props.rawYaml;
    var isNew = this.props.isNew;
    var partner = this.props.partner;
    if (isNew) {
      this.setState({ form: defaultForm(partner) });
    } else if (rawYaml) {
      var parsed = parseYamlToForm(rawYaml);
      if (parsed) this.setState({ form: parsed });
    }
  }

  setFormField(path, value) {
    var form = this.state.form;
    if (!form) return;
    var parts = path.split('.');
    var updated = Object.assign({}, form);
    if (parts.length === 1) {
      updated[parts[0]] = value;
    } else if (parts.length === 2) {
      updated[parts[0]] = Object.assign({}, updated[parts[0]], {
        [parts[1]]: value,
      });
    }
    this.setState({ form: updated });
  }

  handleTableRowChange(tableKey, idx, field, value) {
    var form = this.state.form;
    if (!form) return;
    var tables = Object.assign({}, form.tables);
    var rows = tables[tableKey].slice();
    rows[idx] = Object.assign({}, rows[idx], { [field]: value });
    tables[tableKey] = rows;
    this.setState({ form: Object.assign({}, form, { tables: tables }) });
  }

  handleTableRowAdd(tableKey) {
    var form = this.state.form;
    if (!form) return;
    var tables = Object.assign({}, form.tables);
    tables[tableKey] = tables[tableKey].concat([{ label: '', score: 0 }]);
    this.setState({ form: Object.assign({}, form, { tables: tables }) });
  }

  handleTableRowDelete(tableKey, idx) {
    var form = this.state.form;
    if (!form) return;
    var tables = Object.assign({}, form.tables);
    var rows = tables[tableKey].slice();
    rows.splice(idx, 1);
    tables[tableKey] = rows;
    this.setState({ form: Object.assign({}, form, { tables: tables }) });
  }

  handleSave() {
    var form = this.state.form;
    if (!form) return;
    var yaml = serializeFormToYaml(form);
    this.props.onSave(yaml);
  }

  renderGeneralTab(form) {
    var medium = Number(form.thresholds.medium) || 40;
    var high = Number(form.thresholds.high) || 75;

    return (
      <Box>
        <FormControlLabel
          control={
            <Switch
              checked={form.enabled}
              onChange={function(e) {
                this.setFormField('enabled', e.target.checked);
              }.bind(this)}
              color="success"
            />
          }
          label={
            <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
              {form.enabled ? 'Enabled' : 'Disabled'}
            </Typography>
          }
          sx={{ mb: 3 }}
        />

        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5, color: '#374151' }}>
          Risk Thresholds
        </Typography>
        <Typography sx={{ fontSize: 12, color: '#6B7280', mb: 1.5 }}>
          The accumulated score is compared against these thresholds to assign a
          Low, Medium, or High rating.
        </Typography>

        <ThresholdBar medium={medium} high={high} />

        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
          <TextField
            label="Medium threshold (score ≥)"
            type="number"
            size="small"
            value={form.thresholds.medium}
            onChange={function(e) {
              this.setFormField('thresholds.medium', e.target.value);
            }.bind(this)}
            inputProps={{ min: 1, max: 999, step: 1 }}
            helperText="Scores below this are Low"
            sx={{ width: 220 }}
          />
          <TextField
            label="High threshold (score ≥)"
            type="number"
            size="small"
            value={form.thresholds.high}
            onChange={function(e) {
              this.setFormField('thresholds.high', e.target.value);
            }.bind(this)}
            inputProps={{ min: 1, max: 999, step: 1 }}
            helperText="Scores below this are Medium"
            sx={{ width: 220 }}
          />
        </Box>

        <Divider sx={{ mb: 3 }} />

        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5, color: '#374151' }}>
          Sanctions & PEP Penalty
        </Typography>
        <Typography sx={{ fontSize: 12, color: '#6B7280', mb: 1.5 }}>
          Added to the accumulated score when a customer is flagged on a
          sanctions list or identified as a PEP.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            label="Sanction penalty points"
            type="number"
            size="small"
            value={form.sanction_penalty}
            onChange={function(e) {
              this.setFormField('sanction_penalty', e.target.value);
            }.bind(this)}
            inputProps={{ min: 0, max: 999, step: 1 }}
            helperText="Added when sanction_flagged is true"
            sx={{ width: 200 }}
          />
          <TextField
            label="PEP penalty points"
            type="number"
            size="small"
            value={form.pep_penalty}
            onChange={function(e) {
              this.setFormField('pep_penalty', e.target.value);
            }.bind(this)}
            inputProps={{ min: 0, max: 999, step: 1 }}
            helperText="Added when pep_flagged is true (overridden by PEP category table)"
            sx={{ width: 240 }}
          />
        </Box>
      </Box>
    );
  }

  renderWeightsTab(form) {
    return (
      <Box>
        <Typography sx={{ fontSize: 12, color: '#6B7280', mb: 2.5 }}>
          Weights control how much each factor contributes to the accumulated
          score. The final score for each factor is:&nbsp;
          <strong>weight × category score</strong>. Increase a weight to make
          that factor more influential.
        </Typography>

        <Table size="small" sx={{ mb: 2 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={TH}>Factor</TableCell>
              <TableCell sx={TH}>Description</TableCell>
              <TableCell sx={{ ...TH, width: 130 }}>Weight</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(WEIGHT_META).map(function(key) {
              var meta = WEIGHT_META[key];
              return (
                <TableRow key={key} hover>
                  <TableCell sx={{ ...TD, fontWeight: 600 }}>
                    {meta.label}
                  </TableCell>
                  <TableCell sx={{ ...TD, color: '#6B7280', fontSize: 12 }}>
                    {meta.desc}
                  </TableCell>
                  <TableCell sx={TD}>
                    <TextField
                      size="small"
                      type="number"
                      value={form.weights[key]}
                      onChange={function(e) {
                        this.setFormField('weights.' + key, e.target.value);
                      }.bind(this)}
                      inputProps={{ step: 0.001, min: 0, style: { fontSize: 12 } }}
                      sx={{ width: 110 }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>

        <Box sx={{ bgcolor: '#F0F9FF', border: '1px solid #BAE6FD', borderRadius: 1, p: 1.5 }}>
          <Typography sx={{ fontSize: 12, color: '#0369A1' }}>
            <strong>Example:</strong> A customer with occupation &quot;Bank
            Employee&quot; (category score 26) and occupation weight 0.20 would
            contribute&nbsp;<strong>26 × 0.20 = 5.2</strong> points to their
            total risk score.
          </Typography>
        </Box>
      </Box>
    );
  }

  renderTablesTab(form) {
    var medium = Number(form.thresholds.medium) || 40;
    var high = Number(form.thresholds.high) || 75;
    var countrySearch = this.state.countrySearch;

    return (
      <Box>
        <Typography sx={{ fontSize: 12, color: '#6B7280', mb: 2 }}>
          Each row maps a specific value to a raw score. The weight applied to
          that factor (set in the Weights tab) scales this score in the final
          calculation. Risk band shown is based on the raw score alone against
          the configured thresholds.
        </Typography>

        {SCORE_TABLE_META.map(function(meta) {
          return (
            <ScoreTableAccordion
              key={meta.key}
              meta={meta}
              rows={form.tables[meta.key]}
              medium={medium}
              high={high}
              onChange={this.handleTableRowChange.bind(this)}
              onAdd={this.handleTableRowAdd.bind(this)}
              onDelete={this.handleTableRowDelete.bind(this)}
              search={meta.searchable ? countrySearch : ''}
              onSearchChange={meta.searchable
                ? function(v) { this.setState({ countrySearch: v }); }.bind(this)
                : null}
            />
          );
        }.bind(this))}
      </Box>
    );
  }

  renderYamlTab(form) {
    var yaml = '';
    try { yaml = serializeFormToYaml(form); } catch (e) {}
    return (
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Typography sx={{ fontSize: 12, color: '#6B7280', mb: 1 }}>
          Read-only preview of the YAML that will be published. This is
          generated from your form inputs above.
        </Typography>
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <AceEditor
            mode="yaml"
            theme="monokai"
            value={yaml}
            readOnly={true}
            name="risk-config-yaml-preview"
            width="100%"
            height="100%"
            fontSize={12}
            showPrintMargin={false}
            showGutter={true}
            editorProps={{ $blockScrolling: true }}
            setOptions={{ showLineNumbers: true, tabSize: 2 }}
          />
        </Box>
      </Box>
    );
  }

  render() {
    var open = this.props.open;
    var isNew = this.props.isNew;
    var loading = this.props.loading;
    var saving = this.props.saving;
    var saveError = this.props.saveError;
    var onClose = this.props.onClose;

    var tab = this.state.tab;
    var form = this.state.form;

    var title = isNew ? 'New Risk Configuration' : 'Edit Risk Configuration';
    var subtitle = form ? form.partner : '';

    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: { height: '88vh', display: 'flex', flexDirection: 'column' } }}
      >
        <DialogTitle sx={{
          display: 'flex', alignItems: 'center',
          justifyContent: 'space-between', pb: 0, pt: 2,
        }}>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="caption" sx={{ fontFamily: 'monospace', color: '#6B7280' }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <Tabs
          value={tab}
          onChange={function(_, v) { this.setState({ tab: v }); }.bind(this)}
          sx={{
            px: 2, borderBottom: '1px solid #E5E7EB',
            '& .MuiTab-root': { textTransform: 'none', fontSize: 13, minHeight: 40 },
          }}
        >
          <Tab label="General" />
          <Tab label="Factor Weights" />
          <Tab label="Score Tables" />
          <Tab label="YAML Preview" />
        </Tabs>

        <DialogContent
          sx={{ p: 0, display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}
        >
          {saveError && (
            <Alert severity="error" sx={{ mx: 2, mt: 1 }}>
              {(saveError && saveError.message) || 'Failed to save. Please try again.'}
            </Alert>
          )}

          {loading || !form ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <TabPanel value={tab} index={0}>
                {this.renderGeneralTab(form)}
              </TabPanel>
              <TabPanel value={tab} index={1}>
                {this.renderWeightsTab(form)}
              </TabPanel>
              <TabPanel value={tab} index={2}>
                {this.renderTablesTab(form)}
              </TabPanel>
              <TabPanel value={tab} index={3}>
                {this.renderYamlTab(form)}
              </TabPanel>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 2, py: 1.5, borderTop: '1px solid #E5E7EB' }}>
          <Button onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button
            variant="contained"
            startIcon={saving
              ? <CircularProgress size={16} color="inherit" />
              : <CloudUploadOutlinedIcon />}
            onClick={this.handleSave.bind(this)}
            disabled={saving || loading || !form}
            sx={{
              bgcolor: 'success.main',
              '&:hover': { bgcolor: 'success.dark' },
              textTransform: 'none',
            }}
          >
            {saving ? 'Publishing…' : 'Publish'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default RiskConfigEditor;
